import React, { useState } from 'react';
const faqs = [{
  q: 'How does Netball Ready 360 work?',
  a: 'Immediately after payment, you will receive an email with your download link. You can access all volumes, bonuses, and the tactical playbook directly from your device and start planning your sessions in minutes.'
}, {
  q: 'Does it work for any age group/category?',
  a: 'Yes. The program covers all youth age groups from U10 to Senior across dedicated volumes, plus physical conditioning and shooting content that applies to all ages.'
}, {
  q: 'Can I edit the material?',
  a: 'The materials are provided in high-quality PDF format for easy printing and viewing on any device. While the PDFs themselves are not editable, we provide printable templates and evaluation sheets you can fill out for your team.'
}, {
  q: 'Are the bonuses included?',
  a: 'Yes! All 5 strategic bonuses and the Tactical Playbook Pro are included at no extra cost when you purchase today.'
}, {
  q: 'Is it suitable for beginner coaches?',
  a: "Absolutely. Netball Ready 360 was designed for coaches at every level. Everything is explained step by step with diagrams so you can use it from day one, even if it's your first season."
}, {
  q: 'Useful for school PE too?',
  a: 'Yes. The content is perfectly structured for school PE environments. The sessions work with large groups, require minimal equipment and follow standard curriculum progressions.'
}, {
  q: 'How long does access last?',
  a: 'You get lifetime access to all the materials. Once downloaded, they are yours to keep forever.'
}, {
  q: "What's the difference vs other materials?",
  a: 'Free resources give you individual drills or isolated sessions. Netball Ready 360 gives you a complete system — 200+ sessions organized by age group, a full year planning calendar, tactical playbook, evaluation tools and bonuses. Everything connected, structured and ready to use.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-49">
          Frequently Asked <span className="text-[#6B2FB3]" data-id="element-50">Questions</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-51">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-52">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-53">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-54">
                    {faq.q}
                  </span>
                  <span className={`text-[#6B2FB3] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-55">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-56">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-57">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}